<div class="freshness-chart-container">
  <div>
    <div class="title">Freshness</div>
    <div class="sub-title">Latest Model</div>
  </div>
  <div *ngIf="isDataLoaded">
    <div class="update-section">
      <div class="last-update" *ngIf="sinceLastUpdate !== undefined">
        <div class="update-text">
          Days Since Last Update
        </div>
        <div>
          <div class="update-value">
            {{ sinceLastUpdate }}
          </div>
          <div class="days"><b>Days</b></div>
        </div>
      </div>
      <div class="recent-update" *ngIf="sinceRecentUpdate !== undefined">
        <div class="update-text">
          Days Since the Most Recent update by peer
        </div>
        <div>
          <div class="update-value">
            {{ sinceRecentUpdate }}
          </div>
          <div class="days"><b>Days</b></div>
        </div>
      </div>
      <div class="average" *ngIf="averageAge !== undefined">
        <div class="update-text">
          Average Age of Peer Models
        </div>
        <div>
          <div class="update-value">
            {{ averageAge }}
          </div>
          <div class="days"><b>Days</b></div>
        </div>
      </div>
    </div>
    <div class="period-section">
      <span>120 days</span>
      <span class="period-switch">
        <nz-switch
          nzSize="small"
          [(ngModel)]="this.period"
          (ngModelChange)="setFreshnessPeriod()"
        ></nz-switch>
      </span>
      <span>12 months</span>
    </div>
  </div>
  <div class="chart-section">
    <app-chart-plotter
      *ngIf="chartDataToUse.ticker"
      [chartType]="chartType"
      [dataToUse]="chartDataToUse"
      (chartDataSet)="setCardData($event)"
    ></app-chart-plotter>
  </div>
</div>
